const isMuslinMarket = (
  country: string,
  countriesList: Array<{
    countryCode: string;
    countryName: string;
    minimumAccessAge: number;
    isMuslin?: boolean;
  }>
) => {
  const marketInfo = countriesList?.filter((item) => {
    const code = item.countryCode?.toLowerCase();

    return code === country?.toLowerCase();
  });

  const isMuslin = marketInfo[0]?.isMuslin;

  if (typeof isMuslin !== 'boolean') {
    return false;
  }

  return isMuslin;
};

export { isMuslinMarket };
